import Component from '@glimmer/component';
import {
  startOffset,
  endOffset,
} from '@linc-technologies/linced-common/utils/paper-data-table-pagination';

export default class PaperDataTablePagination extends Component {
  get startOffset() {
    return startOffset(this.args.page, this.args.limit);
  }

  get endOffset() {
    return endOffset(this.args.page, this.args.limit, this.args.total);
  }
}
